import React, { useEffect, useRef } from "react";

function DepositionsCarousel({ children }) {
  const containerRef = useRef();
  const originalChildren = Array.isArray(children) ? children : [children];
  const clonedChildren = [
    ...originalChildren,
    ...originalChildren,
    ...originalChildren,
  ]; // triplica para permitir rolagem infinita

  useEffect(() => {
    const container = containerRef.current;

    const scrollToCenter = () => {
      requestAnimationFrame(() => {
        const middleIndex = originalChildren.length;
        const card = container.children[middleIndex];
        if (card) {
          const offset =
            card.offsetLeft - container.offsetWidth / 2 + card.offsetWidth / 2;
          container.scrollLeft = offset;
        }
      });
    };

    const highlightCenterCard = () => {
      const containerCenter = container.offsetWidth / 2;
      let closestCard = null;
      let minDistance = Infinity;

      container.querySelectorAll(".cardDepositions").forEach((card) => {
        const cardRect = card.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const distance = Math.abs(
          cardCenter - (containerRect.left + containerCenter)
        );

        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
        }
      });

      container.querySelectorAll(".cardDepositions").forEach((card) => {
        card.classList.remove("depositionActive");
      });

      if (closestCard) {
        closestCard.classList.add("depositionActive");
      }
    };

    const onScroll = () => {
      const scrollLeft = container.scrollLeft;
      const containerWidth = container.offsetWidth;

      const firstClone = container.children[originalChildren.length];
      const lastClone = container.children[originalChildren.length * 2 - 1];

      // Loop infinito: volta ao meio se atingir os extremos
      if (scrollLeft <= firstClone.offsetLeft - containerWidth) {
        scrollToCenter();
      } else if (scrollLeft >= lastClone.offsetLeft + lastClone.offsetWidth) {
        scrollToCenter();
      }

      highlightCenterCard();
    };

    // Inicialização após render e carregamento
    const init = () => {
      scrollToCenter();
      highlightCenterCard();
    };

    setTimeout(init, 100); // aguarda render e layout
    container.addEventListener("scroll", onScroll);

    return () => {
      container.removeEventListener("scroll", onScroll);
    };
  }, [children, originalChildren.length]);

  return (
    <div className="containerDepositions sectionAnimate" ref={containerRef}>
      {clonedChildren.map((child, index) =>
        React.cloneElement(child, { key: index })
      )}
    </div>
  );
}

export default DepositionsCarousel;
